import { Stack } from '@mui/material';
import { addDays } from 'date-fns';
import { useState } from 'react';
import { DateRange, Range } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import Modal from '../../../../molecules/Modal';
import PageHeader from './PageHeader';
import PageContent from './page_content';



export default function Main() {

    const [modalOpen, setModalOpen] = useState(false)

    const [state, setState] = useState<[Partial<Range>]>([
        {
          startDate: new Date(),
          endDate: addDays(new Date(), 7),
          key: 'selection'
        }
    ]);

    const handleOnHeaderButtonClick =()=>{
        setModalOpen(modalOpen ? false : true)
    }

    return (

        <Stack
            direction="column"
            spacing={2}
        >
            <PageHeader handleOnHeaderButtonClick={handleOnHeaderButtonClick} />
            <PageContent />
            <Modal
                title="Set date range"
                subtitle="Select date range to display dashboard data"
                visible={modalOpen}
                setVisibility={setModalOpen}
            >
                <div className="flex items-center justify-center">
                    <DateRange
                        onChange={item => setState([item.selection])}
                        showSelectionPreview={false}
                        moveRangeOnFirstSelection={false}
                        ranges={state}
                        direction="horizontal"
                        preventSnapRefocus={true}
                        calendarFocus="backwards"
                    />
                </div>
            </Modal>

        </Stack>
        
    )
}



